export enum StationTWN {
  RMC = 'RMC',
  TPE = 'TPE',
  HSZ = 'HSZ',
  RMQ = 'RMQ',
  KHH = 'KHH'
}
